<script lang="ts">
    import type {Rec} from 'src/typings';
    import {getInjector, getLocalization} from 'src/core';
    import {onDestroy} from 'svelte';
    import {KpRecordClipboardButtonPresenter} from './kp-record-clipboard-button.presenter';
    import KpButton from 'shared/ui-widgets/button/KpButton.svelte';
    import IconedContent from 'shared/ui-widgets/uicons/IconedContent.svelte';

    export let record: Rec;

    const localize = getLocalization();
    const presenter = getInjector().getByClass(KpRecordClipboardButtonPresenter);

    let showAddButton = false;
    let showRemoveButton = false;

    const recordsSubscription = presenter.getRecords$().subscribe(() => {
        showAddButton = presenter.canAddToClipboard(record);
        showRemoveButton = presenter.canRemoveToClipboard(record);
    });

    onDestroy(() => {
        recordsSubscription.unsubscribe();
    });

    const handleAdd = () => {
        presenter.addRecord(record);
    };

    const handleRemove = () => {
        presenter.removeRecord(record);
    };
</script>

{#if showAddButton}
    <KpButton buttonSize="sm"
              additionalClasses="add-to-clipboard-button"
              on:click={handleAdd}
              noWrap
              isBlock>

        <slot name="add">
            <IconedContent icon="check-circle">
                {localize(/* @kp-localization commons.Mark */ 'commons.Mark')}
            </IconedContent>
        </slot>
    </KpButton>
{/if}

{#if showRemoveButton}
    <KpButton buttonStyle="warning"
              buttonSize="sm"
              additionalClasses="remove-from-clipboard-button"
              on:click={handleRemove}
              noWrap
              isBlock>

        <slot name="remove">
            <IconedContent icon="check-circle">
                {localize(/* @kp-localization commons.Marked */ 'commons.Marked')}
            </IconedContent>
        </slot>
    </KpButton>
{/if}